import { createFileRoute, redirect } from '@tanstack/react-router';
import { ResetPasswordWithTokenForm } from '@onesource/components';
import { ResetPasswordSearchParamsSchema } from '@onesource/schemas';
import { AuthLayout } from 'src/layouts/auth';

export const Route = createFileRoute('/auth/reset-password')({
  beforeLoad: ({ search }) => {
    // No token in URL → redirect immediately, never show the form
    if (!search.token) {
      throw redirect({ to: '/auth/login' });
    }
  },
  validateSearch: ResetPasswordSearchParamsSchema,
  component: ResetPassword,
});

function ResetPassword() {
  const { token } = Route.useSearch();

  return (
    <AuthLayout>
      <ResetPasswordWithTokenForm token={token!} />
    </AuthLayout>
  );
}
